import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { LoadingController, Platform } from "ionic-angular";
import { AppSettings } from './app-settings'
// import {Storage} from '@ionic/storage';

import { HttpParams, HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Http, RequestOptions } from '@angular/http';


@Injectable()
export class ServerService {
    adruncount: any = 0;
    adruncount2: any = 0;
    serverURL: any = AppSettings.SERVER_URL;
    constructor(public loadingCtrl: LoadingController,
        // public storage: Storage,
        private plat: Platform,
        private http: Http) { }



    auth(url, params) {

        let isRamatGanServer: string = "0";
        if (params['mercazName'] == "בית עמנואל") {
            isRamatGanServer = "1";
        }

        try {
            let body = new FormData();
            body.append("mercazName", decodeURIComponent(params['mercazName']));
            body.append("userName", decodeURIComponent(params['userName']));
            body.append("password", decodeURIComponent(params['password']));
            body.append("push", localStorage.getItem('push'));
            body.append("isRamatGanServer", isRamatGanServer);
            return this.http.post(AppSettings.SERVER_URL + '' + url, body).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }
    }


    sendPostParams(url, params) {



        let isRamatGanServer: string = "0";
        let beitEmonoalRamatGanServer = localStorage.getItem("beitEmonoalRamatGanServer");
        if (beitEmonoalRamatGanServer == "1") {
            isRamatGanServer = "1";
        }

        if (params['mercazName'] == "בית עמנואל") {
            isRamatGanServer = "1";
        }

        try {
            let body = new FormData();
            body.append("params", JSON.stringify(params));
            body.append("isRamatGanServer", isRamatGanServer);
            return this.http.post(AppSettings.SERVER_URL + '' + url, body).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }


    }


}






// WEBPACK FOOTER //
// ./src/services/server-service.ts